module.exports = __webpack_public_path__ + "img/quality-cost.e4bb3b0e.jpg";